export default function example(fn, options = undefined) {
    void fn, options;
    throw new Error("Unsupported runtime");
}
//# sourceMappingURL=example.js.map